import React, { Component } from 'react';
import { Header } from '../components/Header';
import { EvaSchiffererFooter } from '../components/EvaSchiffererFooter';
import * as Accordion from '@radix-ui/react-accordion';
import { ChevronsDownIcon } from 'lucide-react';
export function EvaSchiffererPaartherapiePage() {
  return <div className="min-h-screen bg-white" data-id="element-1539">
      <Header data-id="element-1540" />
      <main className="w-full pt-[152px]" data-id="element-1541">
        {/* Hero Section mit Bild und Überschrift */}
        <div className="w-full flex justify-center" data-id="element-1542">
          <div className="relative w-full max-w-[1600px] h-[500px]" data-id="element-1543">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/aFUjmDaNr2x4mhcio2jKXW/Header-Paarberatung-Eva_Schifferer.jpg" alt="Eva Schifferer im Gespräch mit einem Paar" className="w-full h-full object-cover" data-id="element-1544" />
            <div className="absolute inset-0 bg-black bg-opacity-30" data-id="element-1545"></div>
            <div className="absolute inset-0 flex items-end pb-12 md:pb-16" data-id="element-1546">
              <div className="max-w-5xl w-full mx-auto px-6 md:px-12" data-id="element-1547">
                <div className="max-w-lg text-left" data-id="element-1548">
                  <blockquote className="text-white text-2xl md:text-3xl font-light italic mb-4" data-id="element-1549">
                    „Liebe ist nicht das, was wir erwarten zu bekommen, sondern
                    das, was wir bereit sind zu geben."
                  </blockquote>
                  <p className="text-white text-xl" data-id="element-1550">– Katharine Hepburn</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Erster Textabschnitt */}
        <div className="max-w-5xl mx-auto pt-16 pb-4 px-6 md:px-12" data-id="element-1551">
          <h1 className="text-3xl md:text-4xl font-light text-gray-700 mb-8" data-id="element-1552">
            Paartherapie
          </h1>
          <div className="text-lg text-gray-600 leading-relaxed space-y-6" data-id="element-1553">
            <p data-id="element-1554">
              Beziehungen sind ein zentraler Bestandteil unseres Lebens – und
              doch widmen wir ihnen oft erst dann gezielte Aufmerksamkeit, wenn
              es nicht mehr „einfach läuft". Wenn Nähe verloren geht, Konflikte
              eskalieren oder grundlegende Fragen aufbrechen, kann eine
              professionelle Perspektive von außen hilfreich sein.
            </p>
            <p data-id="element-1555">
              Beziehungen sind kein Selbstläufer – besonders dann nicht, wenn
              zwei Menschen viel leisten, hohe Ansprüche haben und ihr Alltag
              oft durchgetaktet ist. Umso wichtiger ist es, in das zu
              investieren, was uns im Innersten trägt: unsere Verbindung
              zueinander.
            </p>
          </div>
        </div>
        {/* Zweiter Textabschnitt mit Hintergrund */}
        <div className="w-full bg-gray-50 py-8" data-id="element-1556">
          <div className="max-w-5xl mx-auto px-6 md:px-12" data-id="element-1557">
            <div className="text-lg text-gray-600 leading-relaxed space-y-6" data-id="element-1558">
              <p data-id="element-1559">
                Als Diplom-Psychologin mit fundierter Ausbildung biete ich Ihnen
                integrative, professionelle und wissenschaftlich basierte
                Paartherapie – klar, strukturiert und alltagsnah. Mit Tiefgang,
                Pragmatismus und einem geschulten Blick für Dynamiken, die oft
                unbewusst ablaufen – und mit Lösungen, die in Ihrem Leben
                funktionieren.
              </p>
              <p data-id="element-1560">
                Mein Angebot richtet sich an Menschen, die wissen, dass auch
                Beziehungen Pflege, Aufmerksamkeit und gelegentlich
                professionelle Unterstützung brauchen – und bereit sind, diesen
                Weg bewusst zu gehen.
              </p>
            </div>
          </div>
        </div>
        {/* Neuer Abschnitt: Wann ist Paarberatung und Paartherapie sinnvoll? */}
        <div className="max-w-5xl mx-auto py-16 px-6 md:px-12" data-id="element-1561">
          <h2 className="text-2xl md:text-2xl font-light text-gray-700 mb-6" data-id="element-1562">
            Wann ist Paarberatung und Paartherapie sinnvoll?
          </h2>
          <p className="text-lg text-gray-600 mb-8" data-id="element-1563">
            Paarberatung oder doch Paartherapie? Wer nach Unterstützung sucht,
            trifft schnell auf viele Begriffe – und noch mehr Unsicherheiten.
            Paartherapie und Paarberatung haben fließende Grenzen.
          </p>
          <div className="flex flex-col md:flex-row gap-8 mb-8" data-id="element-1564">
            <div className="md:w-1/2" data-id="element-1565">
              <div className="bg-[#c2cde0] p-6 rounded-lg border-l-4 border-white h-full flex flex-col justify-center" data-id="element-1566">
                <blockquote className="text-xl font-light text-white mb-3 italic" data-id="element-1567">
                  „Es ist nicht wichtig, wie sehr man jemand liebt, sondern wer
                  man ist, wenn man mit dem anderen zusammen ist."
                </blockquote>
                <p className="text-right text-gray-600" data-id="element-1568">– Anne Tyler</p>
              </div>
            </div>
            <div className="md:w-1/2 text-lg text-gray-600" data-id="element-1569">
              <p data-id="element-1570">
                In der Paarberatung geht es eher darum, als Paar in einem
                kürzeren Zeitraum gesetzte Ziele zu erreichen, während Paare in
                der Paartherapie über einen längeren Zeitraum Unterstützung
                erfahren oder tiefer in die Aufarbeitung der Vergangenheit
                einsteigen möchten. In einem ersten Gespräch klären wir
                gemeinsam, was für Ihre Situation der passende Rahmen ist.
              </p>
            </div>
          </div>
          <div className="mb-5" data-id="element-1571">
            <h3 className="text-2xl md:text-2xl font-light text-gray-700 mb-6" data-id="element-1572">
              Typische Anlässe für eine Paarberatung und Paartherapie können zum
              Beispiel sein:
            </h3>
            <Accordion.Root type="single" collapsible className="space-y-4" data-id="element-1573">
              <AccordionItem value="item-1" title="Soll ich bleiben oder gehen?" data-id="element-1574">
                <div className="flex flex-col md:flex-row gap-6" data-id="element-1575">
                  <p className="text-gray-600 leading-relaxed md:w-[50%]" data-id="element-1576">
                    Es lohnt sich immer für eine Beziehung zu kämpfen, denn eine
                    Trennung ist ein einschneidender Schritt. Bei allem Respekt
                    gegenüber dem was war, kann es auch eine Befreiung sein,
                    eine Trennung auszusprechen und sich weiterzuentwickeln.
                    <br data-id="element-1577" />
                    <br data-id="element-1578" />
                    Auf diesem Weg helfen Ratschläge des Umfelds meistens
                    weniger. Ich unterstütze Sie dabei, herauszufinden, was für
                    Sie der nächste passende Schritt ist.
                  </p>
                  <div className="md:w-[50%] flex justify-center items-start" data-id="element-1579">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2vw5pA1dASufuq7voypfzV/Eva_Schifferer-Paarberatung-ac1.jpg" alt="Notizzettel mit 'bleiben oder gehen?' Frage" className="rounded-md shadow-sm w-full" data-id="element-1580" />
                  </div>
                </div>
              </AccordionItem>
              <AccordionItem value="item-2" title="Sexualität und körperliche Nähe haben sich verändert" data-id="element-1581">
                <p className="text-gray-600 leading-relaxed mb-6" data-id="element-1582">
                  Leidenschaft und Intimität sind Spiegel unserer Beziehung und
                  kein Selbstläufer. Was können wir tun, um sie lebendig zu
                  erhalten? Wie können wir ein Gespräch über unsere Wünsche und
                  Bedürfnisse führen? Was machen wir, wenn der körperliche
                  Kontakt zur Belastung oder zum blinden Fleck wird?
                </p>
                <div className="flex flex-col md:flex-row gap-6" data-id="element-1583">
                  <div className="md:w-1/2" data-id="element-1584">
                    <p className="text-gray-600 leading-relaxed" data-id="element-1585">
                      Hier lohnt sich ein offenes Gespräch im geschützten Raum.
                      Denn Wege zu einer erfüllten körperlichen Nähe sind so
                      individuell wie vielfältig – und Lösungen ergeben sich
                      nicht selten aus kleinen Schritten.
                    </p>
                  </div>
                  <div className="md:w-1/2" data-id="element-1586">
                    <div className="bg-[#c2cde0] p-6 rounded-lg border-l-4 border-white h-full flex flex-col justify-center" data-id="element-1587">
                      <blockquote className="text-xl font-light text-white mb-3 italic" data-id="element-1588">
                        "Alles, was im Geist geschieht, wird von Empfindungen im
                        Körper begleitet"
                      </blockquote>
                      <p className="text-right text-gray-600" data-id="element-1589">– Buddha</p>
                    </div>
                  </div>
                </div>
              </AccordionItem>
              <AccordionItem value="item-3" title="Narzissmus in Beziehungen" data-id="element-1590">
                <div className="text-gray-600 leading-relaxed" data-id="element-1591">
                  <p className="mb-4" data-id="element-1592">
                    Manchmal dreht sich in der Beziehung (fast) alles um eine
                    Person: deren Bedürfnisse, deren Erfolge, deren Perspektive.
                    Die andere Seite fühlt sich oft nicht gesehen, nicht gehört
                    – oder sogar manipuliert. Wenn Themen wie emotionale
                    Abwertung, ständiger Streit um Kontrolle, mangelnde Empathie
                    oder das Gefühl, ständig „nicht genug" zu sein, in der
                    Beziehung präsent sind, kann es sich um narzisstische
                    Beziehungsmuster handeln.
                  </p>
                  <p className="font-medium mb-3" data-id="element-1593">Typische Fragen sind:</p>
                  <div className="space-y-4 mb-4" data-id="element-1594">
                    <div className="flex items-start" data-id="element-1595">
                      <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-1596"></div>
                      <p className="text-gray-600" data-id="element-1597">
                        Ist das noch normales Verhalten – oder schon toxisch?
                      </p>
                    </div>
                    <div className="flex items-start" data-id="element-1598">
                      <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-1599"></div>
                      <p className="text-gray-600" data-id="element-1600">
                        Wie gehe ich mit einem Partner oder einer Partnerin um,
                        der/die deutliche narzisstische Präferenzen hat?
                      </p>
                    </div>
                    <div className="flex items-start" data-id="element-1601">
                      <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-1602"></div>
                      <p className="text-gray-600" data-id="element-1603">
                        Kann ich bleiben – und wenn ja: unter welchen
                        Bedingungen?
                      </p>
                    </div>
                    <div className="flex items-start" data-id="element-1604">
                      <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-1605"></div>
                      <p className="text-gray-600" data-id="element-1606">
                        Was macht das mit meinem Selbstwert?
                      </p>
                    </div>
                  </div>
                  <div className="flex flex-col md:flex-row gap-6 mb-6" data-id="element-1607">
                    <div className="md:w-1/2" data-id="element-1608">
                      <p className="text-gray-600 leading-relaxed" data-id="element-1609">
                        In der Beratung schaffen wir einen geschützten Raum, um
                        diese Fragen ehrlich zu beleuchten – mit psychologischem
                        Fachwissen und dem Ziel, Orientierung und emotionale
                        Klarheit zu gewinnen.
                      </p>
                    </div>
                    <div className="md:w-1/2" data-id="element-1610">
                      <div className="bg-[#c2cde0] p-6 rounded-lg border-l-4 border-white h-full flex flex-col justify-center" data-id="element-1611">
                        <blockquote className="text-xl font-light text-white mb-3 italic" data-id="element-1612">
                          „Psychische Gesundheit heißt, sich dafür zu
                          entscheiden, mit Menschen zu leben, die uns nicht
                          krank machen"
                        </blockquote>
                        <p className="text-right text-gray-600" data-id="element-1613">
                          – John Bowlby
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </AccordionItem>
              <AccordionItem value="item-4" title="Lebensveränderungen" data-id="element-1614">
                <div className="text-gray-600 leading-relaxed" data-id="element-1615">
                  <p className="mb-6" data-id="element-1616">
                    Lebensveränderungen wie die Geburt eines Kindes, ein Umzug,
                    neue berufliche Herausforderungen oder eine Erkrankung
                    bringen nicht nur organisatorischen Aufwand mit sich – sie
                    verändern oft auch die Dynamik in der Partnerschaft. Rollen
                    verschieben sich, Routinen brechen weg, Bedürfnisse kommen
                    zu kurz.
                  </p>
                  <div className="flex flex-col md:flex-row gap-6" data-id="element-1617">
                    <div className="md:w-1/2" data-id="element-1618">
                      <p className="text-gray-600 leading-relaxed" data-id="element-1619">
                        Besonders in der Übergangsphase zum Elternsein wird
                        deutlich, wie schwer es sein kann, als Paar verbunden zu
                        bleiben, während der Alltag plötzlich von neuen
                        Verantwortlichkeiten geprägt ist.
                      </p>
                    </div>
                    <div className="md:w-1/2" data-id="element-1620">
                      <div className="bg-[#c2cde0] p-6 rounded-lg border-l-4 border-white h-full flex flex-col justify-center" data-id="element-1621">
                        <blockquote className="text-xl font-light text-white mb-3 italic" data-id="element-1622">
                          „Du bist nicht ein Tropfen im Ozean. Du bist der ganze
                          Ozean in einem Tropfen."
                        </blockquote>
                        <p className="text-right text-gray-600" data-id="element-1623">– Rumi</p>
                      </div>
                    </div>
                  </div>
                </div>
              </AccordionItem>
              <AccordionItem value="item-5" title="Zwischen (Selbst-)Zweifeln und Vertrauen" data-id="element-1624">
                <div className="flex flex-col md:flex-row gap-6" data-id="element-1625">
                  <div className="text-gray-600 leading-relaxed md:w-[50%]" data-id="element-1626">
                    <p className="mb-4" data-id="element-1627">
                      In Zeiten von Social Media sind Vertrauensthemen oft eine
                      Herausforderung. Ein Like hier, eine Story da – und
                      ständig sichtbar, was andere (vermeintlich „bessere")
                      Menschen gerade tun, sagen, zeigen. Wer schreibt mit wem?
                      Was läuft da wirklich?
                    </p>
                    <p className="mb-4" data-id="element-1628">
                      Selbstzweifel, Vergleich und Unsicherheit wachsen oft
                      schleichend – und wenn dann noch ein echter
                      Vertrauensbruch geschieht, wird es richtig schmerzhaft.
                    </p>
                    <p data-id="element-1629">
                      Fremdgehen, ob emotional oder körperlich, erschüttert das
                      Fundament einer Beziehung. Für viele Paare stellt sich
                      dann die Frage: Wie konnte es so weit kommen? Können wir
                      jemals wieder vertrauen? Wollen wir es überhaupt noch
                      gemeinsam versuchen?
                    </p>
                  </div>
                  <div className="md:w-[50%] flex justify-center items-start" data-id="element-1630">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3b1ebnYyJmAvWTaRyV6nwr/Eva_Schifferer-Paarberatung-ac2.jpg" alt="Therapeutin im Gespräch im Freien" className="rounded-md shadow-sm w-full" data-id="element-1631" />
                  </div>
                </div>
                <div className="mt-6" data-id="element-1632">
                  <div className="flex flex-col md:flex-row gap-6" data-id="element-1633">
                    <div className="md:w-1/2" data-id="element-1634">
                      <div className="bg-[#c2cde0] p-6 rounded-lg border-l-4 border-white h-full flex flex-col justify-center" data-id="element-1635">
                        <blockquote className="text-xl font-light text-white mb-3 italic" data-id="element-1636">
                          „Ich glaube, ein Mann will von einer Frau das Gleiche,
                          wie eine Frau von einem Mann: Respekt."
                        </blockquote>
                        <p className="text-right text-gray-600" data-id="element-1637">
                          – Clint Eastwood
                        </p>
                      </div>
                    </div>
                    <div className="md:w-1/2" data-id="element-1638">
                      <p className="text-gray-600 leading-relaxed" data-id="element-1639">
                        In der Beratung biete ich einen Raum, in dem Sie das
                        Erlebte sortieren, verstehen und verarbeiten können –
                        ohne vorschnelle Urteile. Ob es darum geht, nach einer
                        Affäre wieder zueinanderzufinden oder in Ruhe zu klären,
                        ob und wie eine gemeinsame Zukunft aussehen kann: Ich
                        begleite Sie professionell, empathisch und mit
                        psychologischer Klarheit.
                      </p>
                    </div>
                  </div>
                </div>
              </AccordionItem>
              <AccordionItem value="item-6" title="Immer wieder die gleichen Konflikte" data-id="element-1640">
                <div className="flex flex-col md:flex-row gap-6" data-id="element-1641">
                  <div className="text-gray-600 leading-relaxed md:w-[50%]" data-id="element-1642">
                    <p className="mb-4" data-id="element-1643">
                      Wenn Diskussionen sich im Kreis drehen und Verständnis
                      fehlt, kann eine neutrale Perspektive neue Dynamiken
                      eröffnen. Streit an sich ist nicht das Problem – es ist
                      oft sogar ein Zeichen, dass beiden etwas an der Beziehung
                      liegt. Schwierig wird es, wenn sich die Konflikte immer
                      wieder im Kreis drehen.
                    </p>
                    <p className="mb-4" data-id="element-1644">
                      <span className="font-medium" data-id="element-1645">
                        Typische Fragen in diesem Zusammenhang sind:
                      </span>
                    </p>
                    <div className="space-y-4 mb-4" data-id="element-1646">
                      <div className="flex items-start" data-id="element-1647">
                        <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-1648"></div>
                        <p className="text-gray-600" data-id="element-1649">
                          Warum verstehen wir uns so oft falsch – obwohl wir
                          eigentlich dasselbe wollen?
                        </p>
                      </div>
                      <div className="flex items-start" data-id="element-1650">
                        <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-1651"></div>
                        <p className="text-gray-600" data-id="element-1652">
                          Wieso eskalieren Kleinigkeiten?
                        </p>
                      </div>
                      <div className="flex items-start" data-id="element-1653">
                        <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-1654"></div>
                        <p className="text-gray-600" data-id="element-1655">
                          Warum wiederholen sich bestimmte Dynamiken – trotz
                          guter Vorsätze?
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="md:w-[50%] flex justify-center items-start" data-id="element-1656">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/gAQDc6wbMR9XPrcvipobVM/Eva_Schifferer-Paarberatung-ac3.jpg" alt="Hand schreibt 'Konflikte de-eskalieren' auf einen Zettel" className="rounded-md shadow-sm w-full" data-id="element-1657" />
                  </div>
                </div>
                <div className="mt-6" data-id="element-1658">
                  <p className="text-gray-600 leading-relaxed mb-6" data-id="element-1659">
                    Hinter diesen wiederkehrenden Auseinandersetzungen stehen
                    meist tieferliegende Bedürfnisse, unausgesprochene
                    Erwartungen oder alte Beziehungsmuster. In der Beratung
                    schauen wir gemeinsam auf diese Strukturen – mit dem Ziel,
                    neue Wege im Umgang miteinander zu entwickeln.
                  </p>
                  <div className="flex flex-col md:flex-row gap-6" data-id="element-1660">
                    <div className="md:w-1/2" data-id="element-1661">
                      <div className="bg-[#c2cde0] p-6 rounded-lg border-l-4 border-white h-full flex flex-col justify-center" data-id="element-1662">
                        <blockquote className="text-xl font-light text-white mb-3 italic" data-id="element-1663">
                          „Wir sehen die Dinge nicht wie sie sind, sondern wie
                          wir sind"
                        </blockquote>
                        <p className="text-right text-gray-600" data-id="element-1664">– Anais Nin</p>
                      </div>
                    </div>
                    <div className="md:w-1/2" data-id="element-1665">
                      <p className="text-gray-600 leading-relaxed" data-id="element-1666">
                        Dabei geht es darum, wieder in Verbindung zu kommen: auf
                        Augenhöhe, mit Klarheit und mit dem Wunsch, sich
                        gegenseitig besser zu verstehen – statt sich im Konflikt
                        zu verlieren.
                      </p>
                    </div>
                  </div>
                </div>
              </AccordionItem>
              <AccordionItem value="item-7" title="Single-Beratung: Ist er oder sie die/der Richtige?" data-id="element-1667">
                <div className="flex flex-col md:flex-row gap-6" data-id="element-1668">
                  <div className="text-gray-600 leading-relaxed md:w-[50%]" data-id="element-1669">
                    <p className="mb-4" data-id="element-1670">
                      Die Phase der Partnersuche oder der Beginn einer neuen
                      Beziehung kann aufregend sein – aber auch verunsichern.
                      Viele erleben dabei wiederkehrende Muster: sich zu schnell
                      zu binden, sich immer wieder auf unpassende Partner*innen
                      einzulassen oder sich in Ambivalenz zu verlieren.
                    </p>
                    <p className="mb-4" data-id="element-1671">
                      <span className="font-medium" data-id="element-1672">
                        Vielleicht fragen Sie sich:
                      </span>
                    </p>
                    <div className="space-y-4 mb-4" data-id="element-1673">
                      <div className="flex items-start" data-id="element-1674">
                        <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-1675"></div>
                        <p className="text-gray-600" data-id="element-1676">
                          Warum gerate ich immer wieder an den „falschen" Typ?
                        </p>
                      </div>
                      <div className="flex items-start" data-id="element-1677">
                        <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-1678"></div>
                        <p className="text-gray-600" data-id="element-1679">
                          Wie erkenne ich frühzeitig, ob jemand wirklich zu mir
                          passt?
                        </p>
                      </div>
                      <div className="flex items-start" data-id="element-1680">
                        <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-1681"></div>
                        <p className="text-gray-600" data-id="element-1682">
                          Ist es „nur die Angst vor Nähe" – oder stimmt hier
                          tatsächlich etwas nicht?
                        </p>
                      </div>
                      <div className="flex items-start" data-id="element-1683">
                        <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-1684"></div>
                        <p className="text-gray-600" data-id="element-1685">
                          Ist meine Erwartung zu hoch – oder meine
                          Toleranzgrenze zu niedrig?
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="md:w-[50%] flex justify-center items-start" data-id="element-1686">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/uyMHPaBeGgBhzvub2q9ge7/Eva_Schifferer-Paarberatung-ac4.jpg" alt="Notizzettel mit 'Single-Beratung' Aufschrift" className="rounded-md shadow-sm w-full" data-id="element-1687" />
                  </div>
                </div>
                <div className="mt-6" data-id="element-1688">
                  <p className="text-gray-600 leading-relaxed mb-6" data-id="element-1689">
                    In der Einzelberatung werfen wir einen fundierten Blick auf
                    Ihre Beziehungsbiografie, persönliche Muster und innere
                    Dynamiken. Ziel ist nicht, schnelle Urteile zu fällen –
                    sondern Klarheit zu schaffen: über Ihre Bedürfnisse, Ihre
                    Grenzen und das, was Sie wirklich in einer Partnerschaft
                    suchen.
                  </p>
                  <div className="flex flex-col md:flex-row gap-6" data-id="element-1690">
                    <div className="md:w-1/2" data-id="element-1691">
                      <div className="bg-[#c2cde0] p-6 rounded-lg border-l-4 border-white h-full flex flex-col justify-center" data-id="element-1692">
                        <blockquote className="text-xl font-light text-white mb-3 italic" data-id="element-1693">
                          „Deine Aufgabe ist es nicht, nach Liebe zu suchen,
                          sondern lediglich in Dir all die Hürden zu suchen und
                          zu finden, die Du gegen sie errichtet hast"
                        </blockquote>
                        <p className="text-right text-gray-600" data-id="element-1694">– Rumi</p>
                      </div>
                    </div>
                    <div className="md:w-1/2" data-id="element-1695">
                      <p className="text-gray-600 leading-relaxed" data-id="element-1696">
                        Die Frage „Ist er oder sie der/die Richtige?" ist selten
                        einfach zu beantworten. Aber mit professioneller
                        Unterstützung lässt sich ein Weg finden, der nicht aus
                        alten Mustern, sondern aus bewussten Entscheidungen
                        entsteht.
                      </p>
                    </div>
                  </div>
                </div>
              </AccordionItem>
            </Accordion.Root>
          </div>
        </div>
        {/* Informationen zum Ablauf */}
        <div className="max-w-5xl mx-auto pt-2 pb-16 px-6 md:px-12 bg-white" data-id="element-1697">
          <h2 className="text-2xl md:text-2xl font-light text-gray-700 mb-8" data-id="element-1698">
            Informationen zum Ablauf
          </h2>
          <div className="text-lg text-gray-600 leading-relaxed mb-10" data-id="element-1699">
            <p data-id="element-1700">
              Der erste Schritt in eine gemeinsame Veränderung beginnt mit einem
              offenen Gespräch. Manchmal geht der Wunsch nach Unterstützung
              zunächst nur von einer Seite aus – das ist nicht ungewöhnlich.
              Auch dann kann es sinnvoll sein, erste Schritte zu besprechen und
              Orientierung zu gewinnen. Der erste Kontakt kann dabei auch nur
              mit einem der Partner stattfinden.
            </p>
          </div>
          <div className="mb-12" data-id="element-1701">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wMWkyx7TjL348UyJGDAAsU/Eva_Schifferer-Paarberatung-Ablauf.jpg" alt="Frau mit Laptop bei Online-Beratung" className="w-full h-auto rounded-lg shadow-md mb-12" data-id="element-1702" />
            <div className="space-y-4" data-id="element-1703">
              <div className="bg-gray-50 p-6 rounded-lg" data-id="element-1704">
                <h3 className="text-xl font-medium text-gray-700 mb-4" data-id="element-1705">
                  Start der Beratung
                </h3>
                <p className="text-gray-600" data-id="element-1706">
                  Entscheiden Sie sich für die Zusammenarbeit, beginnt die
                  eigentliche Paartherapie. In der Regel arbeiten wir in
                  Sitzungen à 90 Minuten – je nach Thema und Intensität.
                </p>
              </div>
              <div className="bg-gray-50 p-6 rounded-lg" data-id="element-1707">
                <h3 className="text-xl font-medium text-gray-700 mb-4" data-id="element-1708">
                  Dauer und Häufigkeit
                </h3>
                <p className="text-gray-600" data-id="element-1709">
                  Die Dauer der Beratung ist individuell. Manche Anliegen klären
                  sich in wenigen Sitzungen, andere benötigen mehr Zeit. Wie
                  viele Gespräche Sie in Anspruch nehmen möchten, richtet sich
                  nach der Komplexität der Themen und den Zielen, die sie
                  erreichen möchten.
                </p>
                <p className="text-gray-600 mt-4" data-id="element-1710">
                  In der Regel finden die Sitzungen im Abstand von zwei bis vier
                  Wochen statt, denn die wirkliche Veränderung entsteht in Ihrem
                  Alltag.
                </p>
              </div>
            </div>
            <div className="mt-8 text-center" data-id="element-1711">
              <p className="text-gray-600" data-id="element-1712">
                Weitere Informationen zum Ablauf und Terminbuchung, finden Sie{' '}
                <a href="/eva_schifferer/info" className="text-[#c2cde0] hover:text-[#a3b3d4] hover:font-semibold transition-colors" data-id="element-1713">
                  hier
                </a>
                .
              </p>
            </div>
          </div>
        </div>
      </main>
      <EvaSchiffererFooter data-id="element-1714" />
    </div>;
}
// Accordion Item Component
const AccordionItem = ({
  children,
  value,
  title
}) => {
  return <Accordion.Item value={value} className="border-b border-gray-200 overflow-hidden" data-id="element-1715">
      <Accordion.Header data-id="element-1716">
        <Accordion.Trigger className="flex justify-between items-center w-full p-4 text-left bg-white hover:bg-gray-50 transition-colors" data-id="element-1717">
          <span className="text-lg font-medium text-gray-700" data-id="element-1718">{title}</span>
          <ChevronsDownIcon className="h-5 w-5 text-[#c2cde0] transition-transform duration-300 ease-[cubic-bezier(0.87,0,0.13,1)] group-data-[state=open]:rotate-180" data-id="element-1719" />
        </Accordion.Trigger>
      </Accordion.Header>
      <Accordion.Content className="overflow-hidden data-[state=open]:animate-slideDown data-[state=closed]:animate-slideUp" data-id="element-1720">
        <div className="p-4 bg-white" data-id="element-1721">{children}</div>
      </Accordion.Content>
    </Accordion.Item>;
};